/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_M2_MonthInputs */

const cs_enum_m2_month = /** @type {(inputs: Enum_M2_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m² / měsíc`)
};

const en_enum_m2_month = /** @type {(inputs: Enum_M2_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m² / month`)
};

/**
* | output |
* | --- |
* | "m² / month" |
*
* @param {Enum_M2_MonthInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_m2_month = /** @type {((inputs?: Enum_M2_MonthInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_M2_MonthInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_m2_month(inputs)
	return cs_enum_m2_month(inputs)
});